import React, { forwardRef, useEffect, useState } from 'react';

const Input = forwardRef(
    ({ name, label, type, value, required, readOnly, onChange, onBlur, disabled, ...rest }, ref) => {
        const [_value, setValue] = useState(value);

        useEffect(() => {
            if (value !== _value) {
                setValue(value);
            }
        }, [value]);

        // We can use the onBlue function, without passing the onChange function in props.
        // Component will manage the value internally.
        const onChangeHandler = (e) => {
            const inputValue = e.target.value;
            setValue(inputValue);
            onChange?.(inputValue, e);
        }

        const onBlurHandler = (e) => {
            onBlur?.(_value, e);
        }

        const commonProps = {
            ref,
            className: 'form-control',
            name,
            value: _value ?? '',
            readOnly,
            disabled,
            onChange: (e) => !disabled && onChangeHandler(e),
            onBlur: (e) => !disabled && onBlurHandler(e),
            ...rest,
        };

        return (
            <div className='form-group'>
                {label && (
                    <label className={required ? 'form-control-required' : ''}>{label}</label>
                )}
                {type === 'textarea' ? <textarea {...commonProps} /> : <input {...commonProps} />}
            </div>
        );
    }
);

Input.defaultProps = {
    name: null,
    label: null,
    type: 'text',
    required: false,
    value: '',
    placeholder: '',
    readOnly: false,
    disabled: false,
};

export default Input;
